import React from 'react';

const ZONES = {
  frontBumper: [52, 24, 116, 22, 10], hoodFront: [58, 48, 104, 30, 6], hood: [58, 80, 104, 40, 6],
  roofFront: [64, 122, 92, 26, 4], roof: [66, 150, 88, 74, 8], trunk: [64, 254, 92, 54, 6],
  rearBumper: [52, 310, 116, 22, 10], fenderL: [42, 48, 16, 72, 5], fenderR: [162, 48, 16, 72, 5],
  doorL: [44, 150, 16, 104, 4], doorR: [160, 150, 16, 104, 4], quarterL: [44, 254, 16, 54, 5],
  quarterR: [160, 254, 16, 54, 5], rockerL: [36, 150, 6, 158, 3], rockerR: [178, 150, 6, 158, 3],
  mirrorL: [26, 146, 12, 14, 4], mirrorR: [182, 146, 12, 14, 4],
};

export default function VehicleCoverageMap({ active = [], compact = false, label = true }) {
  return (
    <div className={`coverage-map ${compact ? 'coverage-map-compact' : ''}`}>
      <svg viewBox="0 0 220 356" className="w-full mx-auto" role="img" aria-label="Top view vehicle coverage map" data-testid="ppf-car-diagram">
        <rect x="38" y="18" width="144" height="320" rx="34" fill="#f6f4f0" stroke="#d6d1c9" strokeWidth="1.5" />
        <rect x="64" y="120" width="92" height="30" rx="4" fill="#cdd6dd" />
        <rect x="64" y="226" width="92" height="30" rx="4" fill="#cdd6dd" />
        {Object.entries(ZONES).map(([key, [x, y, w, h, rx]]) => (
          <rect key={key} data-testid={`zone-${key}`} x={x} y={y} width={w} height={h} rx={rx} className={`zone ${active.includes(key) ? 'zone-on' : ''}`} />
        ))}
      </svg>
      {label && <p className="meta text-center mt-4">Top view · <span className="text-red">red</span> = protected panels</p>}
    </div>
  );
}
